import { AuthService } from './authService';
import { extractApiError } from '../utils/apiError';
import {
  ItemTypeChangePreview,
  ItemTypeChangeRequest,
  ItemTypeChangeResult,
  PlaceholderEditorState,
  PlaceholderEditRequest,
  PlaceholderEditResult,
} from '../types/itemTypeChange';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://localhost:7141/api/v1';

class ItemTypeChangeService {
  async getPreview(itemNo: string, newItemType: number): Promise<ItemTypeChangePreview> {
    const url = `${API_BASE_URL}/item-type-change/preview?itemNo=${encodeURIComponent(itemNo)}&newItemType=${newItemType}`;
    const response = await AuthService.authenticatedGet(url);
    if (!response.ok) {
      const err = await response.json().catch(() => null);
      throw new Error(extractApiError(err, response, 'Kunne ikke hente forhåndsvisning'));
    }
    return await response.json();
  }

  async execute(request: ItemTypeChangeRequest): Promise<ItemTypeChangeResult> {
    const response = await AuthService.authenticatedPost(
      `${API_BASE_URL}/item-type-change/execute`,
      request
    );
    if (!response.ok) {
      const err = await response.json().catch(() => null);
      throw new Error(extractApiError(err, response, 'Kunne ikke utføre endring'));
    }
    return await response.json();
  }

  async getPlaceholders(itemNo: string): Promise<PlaceholderEditorState> {
    const url = `${API_BASE_URL}/item-type-change/placeholders?itemNo=${encodeURIComponent(itemNo)}`;
    const response = await AuthService.authenticatedGet(url);
    if (!response.ok) {
      const err = await response.json().catch(() => null);
      throw new Error(extractApiError(err, response, 'Kunne ikke hente placeholders'));
    }
    return await response.json();
  }

  async savePlaceholders(request: PlaceholderEditRequest): Promise<PlaceholderEditResult> {
    const response = await AuthService.authenticatedPost(
      `${API_BASE_URL}/item-type-change/placeholders`,
      request
    );
    if (!response.ok) {
      const err = await response.json().catch(() => null);
      throw new Error(extractApiError(err, response, 'Kunne ikke lagre placeholders'));
    }
    return await response.json();
  }
}

export const itemTypeChangeService = new ItemTypeChangeService();
